import { createFeatureSelector, createSelector, select } from '@ngrx/store';
import { CitiesState } from '../../models/cities-state.model';

export const selectCitiesState = createFeatureSelector<CitiesState>('cities');

export const selectCities = createSelector(
    selectCitiesState,
    (state: CitiesState) => state.cities
);

export const selectUserSelectedCity = createSelector(
    selectCitiesState,
    (state: CitiesState) => state.userSelectedCity
);